<div class="overflow-x-auto sm:overflow-y-auto overflow-y-hidden">
  <table mat-table [dataSource]="observations" multiTemplateDataRows class="mb-3">
    <ng-container matColumnDef="{{ column }}" *ngFor="let column of columnsToDisplay">
      <ng-container [ngSwitch]="column">
        <ng-container *ngSwitchCase="'observation_flag'">
          <th mat-header-cell *matHeaderCellDef class="text-white text-md"></th>
          <td mat-cell *matCellDef="let element" class="text-sm">
            <mat-icon
              *ngIf="element[column] !== 'observation_on_floor_plan'"
              class="icon-size-5"
              svgIcon="radio_button_checked"
            ></mat-icon>
            <mat-icon
              *ngIf="element[column] === 'observation_on_floor_plan'"
              class="icon-size-5"
              svgIcon="map"
            ></mat-icon>
          </td>
        </ng-container>
        <ng-container *ngSwitchCase="'categories'">
          <th mat-header-cell *matHeaderCellDef class="text-white text-md">
            {{ 'Categories' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element" class="text-sm px-1">
            <span *ngFor="let category of element[column]; let key = index">
              {{ key === 1 ? ',' : '' }}{{ category.category_name_en }}</span
            >
          </td>
        </ng-container>
        <ng-container *ngSwitchCase="'creator'">
          <th mat-header-cell *matHeaderCellDef class="text-white text-md">
            {{ 'Created By' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element" class="text-sm px-1">
            <span>{{ element[column]?.name | titlecase }}</span>
          </td>
        </ng-container>
        <ng-container *ngSwitchCase="'unifier_observation_id'">
          <th mat-header-cell *matHeaderCellDef class="text-white text-md">
            {{ 'record_no' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element" class="text-sm px-1">
            <div class="truncate break-words" style="max-width: 15vw">
              {{ element[column] ? (element[column] | uppercase) : '-' }}
            </div>
          </td>
        </ng-container>
        <ng-container *ngSwitchCase="'unifier_sequence_number'">
          <th mat-header-cell *matHeaderCellDef class="text-white text-md">
            {{ 'sequence_no' | transloco }}
          </th>
          <td mat-cell *matCellDef="let element" class="text-sm px-1">
            <div class="truncate break-words" style="max-width: 15vw">
              {{ element[column] ? (element[column] | uppercase) : '-' }}
            </div>
          </td>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <th mat-header-cell *matHeaderCellDef class="text-white text-md">
            {{ column | transloco }}
          </th>
          <td mat-cell *matCellDef="let element" class="text-sm px-1">
            <div
              class="truncate break-words"
              style="max-width: 25vw"
              [innerHTML]="
                column === 'created_at' ? (element[column] | dateTransform) : element[column]
              "
            ></div>
          </td>
        </ng-container>
      </ng-container>
    </ng-container>

    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
    <ng-container matColumnDef="expandedDetail">
      <td
        class="bg-accent-700 px-1"
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="columnsToDisplay.length"
      >
        <div
          class="example-element-detail w-full"
          [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'"
        >
          <div class="flex flex-row justify-start p-4">
            <div class="w-1/3 p-2">
              <div class="border rounded-sm border-primary p-0.5 bg-accent-700">
                <img
                  [src]="element.screen_shot"
                  [alt]="element.title"
                  style="max-height: 250px !important"
                />
              </div>
            </div>
            <div class="w-2/3 flex flex-wrap ps-8">
              <div class="w-1/2 flex flex-col">
                <div>
                  <label for="significance">{{ 'significance' | transloco }}: </label>
                  <span id="significance">{{ element.significance_label }}</span>
                </div>
                <div>
                  <label for="privacy">{{ 'privacy' | transloco }}: </label>
                  <span id="privacy">{{ element.privacy | transloco }}</span>
                </div>
                <div>
                  <label for="count_of_attached">{{ 'attaches-count' | transloco }}: </label>
                  <span id="count_of_attached">{{ element.count_of_attached }}</span>
                </div>
                <div>
                  <label for="count_of_attached">{{ 'Due Date' | transloco }}: </label>
                  <span [innerHTML]="element.due_date | dateTransform"></span>
                </div>
              </div>
              <div class="w-1/2 flex-col items-stretch justify-between">
                <div>
                  <label for="categories">{{ 'categories' | transloco }}:</label><br />
                  <span
                    id="categories"
                    class="pill bg-accent-900"
                    *ngFor="let cat of element.categories"
                    >{{ cat.category_name_en }}
                  </span>
                </div>
              </div>
              <div class="flx-col">
                <label for="description">{{ 'description' | transloco }}:</label>
                <div id="description" class="break-words" style="max-width: 30vw">
                  {{ element.description }}
                </div>
              </div>
              <div class="w-full flex justify-end is-mobile">
                <button
                  mat-button
                  color="primary"
                  mat-dialog-close
                  [routerLink]="'/observations/details/' + element.id"
                >
                  {{ 'view-observation' | transloco }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="bg-primary-800"></tr>
    <tr
      mat-row
      *matRowDef="let element; columns: columnsToDisplay"
      class="example-element-row"
      [class.example-expanded-row]="expandedElement === element"
      (click)="expandedElement = expandedElement === element ? null : element"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
  </table>

  <div
    *ngIf="observations.length === 0"
    class="mat-elevation-z8 w-full h-60 text-secondary justify-center flex items-center mb-3"
  >
    {{ 'no-observations' | transloco }}
  </div>
</div>
